<div class="top-categeryHead" [ngClass]="customStyle">
    <div class="categeryHead-text">
        <h1 [outerHTML]="headingText()"></h1>
    </div>
    <button *ngIf="showDiv" class="cat-viewBtn"> View All <img src="/assets/images/rightArrow.svg"
            class="catButton-arrow" alt="btn " /></button>
</div>
